import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { BaseService } from '../base';
import { MatSnackBar } from '@angular/material/snack-bar'; 
import { ContactDTO, ContactModel } from '../../modules/contact/contact/contact.model';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/base';

const CONTACTOS_ENDPOINT = '/contacts/';

@Injectable({ providedIn: 'root' })
export class ContactosService extends BaseService {
  // #region Propiedades
  private proveedores: ContactModel[] = [];
  p$: BehaviorSubject<ContactModel[]> = new BehaviorSubject<ContactModel[]>([]);
  proveedores$: Observable<ContactModel[]> = this.p$.asObservable();

  private proveedoresDTO: ContactDTO[] = [];
  pd$: BehaviorSubject<ContactDTO[]> = new BehaviorSubject<ContactDTO[]>([]);
  proveedoresDTO$: Observable<ContactDTO[]> = this.pd$.asObservable();

  loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // #endregion

  constructor(
    private httpClient: HttpClient,
    protected snackBar: MatSnackBar
  ) {
    super(snackBar);
  }

  // #region Métodos relacionados con la API

  /**
   * Obtiene la lista de proveedores.
   */
  listaProveedores(): void {
    const url = `${environment.apiUrl}${CONTACTOS_ENDPOINT}providers`;

    this.loading$.next(true);

    this.httpClient
      .get<ApiResponse<ContactModel[]>>(url)
      .pipe(
        map((resultado) => {
          const proveedores = resultado && resultado.data ? resultado.data : [];

          return [...proveedores].sort((a: ContactModel, b: ContactModel) =>
            a.companyName.localeCompare(b.companyName)
          );
        }),
        finalize(() => {
          this.loading$.next(false);
        })
      )
      .subscribe({
        next: (proveedores) => {
          this.proveedores = proveedores;
          this.p$.next(this.proveedores);
        },
        error: (error: any) => {
          this.procesarError(error);
        },
      });
  }

  /**
   * Obtiene la lista de proveedores en formato DTO.
   */
  listaProveedoresDTO(): void {
    const url = `${environment.apiUrl}${CONTACTOS_ENDPOINT}providers/dtos`;

    this.loading$.next(true);

    this.httpClient
      .get<ContactDTO[]>(url)
      .pipe(
        map((resultado: ContactDTO[]) => {
          const proveedoresDTO = resultado || [];

          return [...proveedoresDTO].sort((a: ContactDTO, b: ContactDTO) =>
            a.companyName.localeCompare(b.companyName)
          );
        }),
        finalize(() => {
          this.loading$.next(false);
        })
      )
      .subscribe({
        next: (proveedoresDTO: ContactDTO[]) => {
          this.proveedoresDTO = proveedoresDTO;
          this.pd$.next(this.proveedoresDTO);
        },
        error: (error: any) => {
          this.procesarError(error);
        },
      });
  }

  // #endregion

  // #region Métodos de gestión interna

  /**
   * Obtiene un proveedor por su id.
   * @param id Identificador del proveedor
   * @returns Proveedor
   */
  obtenerProveedorDTOPorId(id: number): ContactDTO {
    return this.proveedoresDTO.find((p: ContactDTO) => p.id == id);
  }

  // #endregion
}